import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { InstructionMenu } from 'src/Components/Drawers/ViewInstructionDrawer/InstructionMenu';
import { InstructionDetails } from 'src/Components/Instructions/InstructionDetails';
import useFetchInstruction from 'src/Hooks/Queries/useFetchInstruction';

type EventParams = {
  instructionId: string;
};

const ViewInstructionDrawer = () => {
  const { t } = useTranslation();
  const { instructionId } = useParams<EventParams>();
  const { data } = useFetchInstruction(instructionId);

  if (!instructionId) {
    return <Navigate to="/" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('instructionDetailsDrawer.title', 'Consigne')}>
      {({ onClose }) =>
        data && (
          <InstructionDetails
            instruction={data}
            onClose={onClose}
            menu={data && <InstructionMenu instruction={data} onDelete={onClose} />}
          />
        )
      }
    </AnimatedRoutedDrawer>
  );
};

export default ViewInstructionDrawer;
